import { Sparkles } from 'lucide-react';

import { suggestedPromptsFor } from '@/app/agentConversation/_helpers';

import { Button } from '@/app/ui/button';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/app/ui/empty';

/** A new conversation: what the assistant is for, and a few things to ask from here. */
const EmptyState = ({ view, tab, onSend }) => {
  return (
    <Empty className="border-0" data-testid="agent-empty">
      <EmptyHeader>
        <EmptyMedia>
          <Sparkles />
        </EmptyMedia>
        <EmptyTitle>Ask About Your Data</EmptyTitle>
        <EmptyDescription>Questions about your projects, estimates and records. It can read anything you can, and change nothing.</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <div className="flex w-full flex-col gap-1.5">
          {suggestedPromptsFor(view, tab).map((prompt) => (
            <SuggestedPrompt key={prompt} prompt={prompt} onSend={onSend} />
          ))}
        </div>
      </EmptyContent>
    </Empty>
  );
};

const SuggestedPrompt = ({ prompt, onSend }) => {
  const handleClick = () => onSend(prompt);

  return (
    <Button variant="outline" size="sm" className="h-auto justify-start py-1.5 text-left whitespace-normal" onClick={handleClick} data-testid="agent-suggested-prompt">
      {prompt}
    </Button>
  );
};

export default EmptyState;
